export default __webpack_public_path__ + "static/media/home-w.213029c6.svg";